
export class NotNullExpected extends TypeError {
    public name = 'NotNullExpected';
}
